import React from 'react';
import { Checkbox } from '@mui/material';

export const RowCheckbox = ({ isSelected, handleChange }) => {
  return (
    <Checkbox checked={isSelected} onChange={handleChange} size="small" style={{ padding: 0 }} />
  );
};
